var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87179 16H4.12821C1.50769 16 0 14.4372 0 11.7209V4.27907C0 1.56279 1.50769 0 4.12821 0H9.87179C12.4923 0 14 1.56279 14 4.27907V11.7209C14 14.4372 12.4923 16 9.87179 16ZM4.12821 1.11628C2.07487 1.11628 1.07692 2.1507 1.07692 4.27907V11.7209C1.07692 13.8493 2.07487 14.8837 4.12821 14.8837H9.87179C11.9251 14.8837 12.9231 13.8493 12.9231 11.7209V4.27907C12.9231 2.1507 11.9251 1.11628 9.87179 1.11628H4.12821Z",
    fill: "#F1722E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 5.9524H10.2307C9.13942 5.9524 8.25635 5.03705 8.25635 3.90589V2.41751C8.25635 2.1124 8.50045 1.85938 8.79481 1.85938C9.08917 1.85938 9.33327 2.1124 9.33327 2.41751V3.90589C9.33327 4.41937 9.73532 4.83612 10.2307 4.83612H11.6666C11.961 4.83612 12.2051 5.08914 12.2051 5.39426C12.2051 5.69937 11.961 5.9524 11.6666 5.9524Z",
    fill: "#F1722E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0001 9.30183H4.12831C3.83395 9.30183 3.58984 9.0488 3.58984 8.74369C3.58984 8.43857 3.83395 8.18555 4.12831 8.18555H7.0001C7.29446 8.18555 7.53856 8.43857 7.53856 8.74369C7.53856 9.0488 7.29446 9.30183 7.0001 9.30183Z",
    fill: "#F1722E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87189 12.2803H4.12831C3.83395 12.2803 3.58984 12.0273 3.58984 11.7222C3.58984 11.4171 3.83395 11.1641 4.12831 11.1641H9.87189C10.1663 11.1641 10.4104 11.4171 10.4104 11.7222C10.4104 12.0273 10.1663 12.2803 9.87189 12.2803Z",
    fill: "#F1722E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/generateIcon.b7342c12.svg";
export { ForwardRef as ReactComponent };